/**
 * GET `admin/tariffs` — активные версии тарифов + история (ADMIN_SPEC §3.6).
 * Gateway говорит camelCase и в тыйынах — конверсию кейсов глушим,
 * деньги переводит маппер. Без BE (VITE_API_BASE_URL пуст) — мок.
 */

import {apiEnabled, http} from '@services/utils';

import {CURRENT_CLINIC, CURRENT_SOLO, TARIFF_HISTORY} from '../mocks';
import type {TariffsBundle} from '../types';

import {toTariffsBundle} from './toTariffsBundle';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getTariffs = async (): Promise<TariffsBundle> => {
  if (!apiEnabled) {
    await sleep(220);
    return {
      solo: {...CURRENT_SOLO},
      clinic: {...CURRENT_CLINIC, packages: CURRENT_CLINIC.packages.map((p) => ({...p}))},
      history: TARIFF_HISTORY.map((h) => ({...h})),
    };
  }

  const raw = await http<Record<string, unknown>>('admin/tariffs', {skipCaseConversion: true});
  return toTariffsBundle(raw);
};
